import React, { useState } from 'react';
import { func, object } from 'prop-types';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import Toggle from '../../shared/Toggle';

const ListPrivacyToggle = props => {
  const [isPrivate, togglePrivate] = useState(!!props.list.private);

  const togglePrivacy = () => {
    ServerCommunicationUtil.putApiEndpoint(
      `/api/alltrails/lists/${props.list.id}`,
      { private: !isPrivate },
      () => {
        props.onPrivacyChange(!isPrivate);
        togglePrivate(!isPrivate);
      },
      () => {},
      () => {}
    );
  };

  return <Toggle inputId="listPrivacyToggle" onChange={togglePrivacy} checked={isPrivate} label={StringConstantsMixin.strings.PRIVATE_LIST} />;
};

ListPrivacyToggle.propTypes = {
  onPrivacyChange: func.isRequired,
  list: object.isRequired
};

export default ListPrivacyToggle;
